<template>
	<img :src="iconSrc" :alt="alt" class="sidebar-icon" :style="iconStyle" />
</template>

<script setup>
import { computed } from "vue";
import orderIcon from "./icons/sidebar-order.svg";
import followIcon from "./icons/sidebar-follow.svg";
import messageIcon from "./icons/sidebar-message.svg";
import couponIcon from "./icons/sidebar-coupon.svg";
import fileIcon from "./icons/sidebar-file.svg";
import addressIcon from "./icons/sidebar-address.svg";
import accountIcon from "./icons/sidebar-account.svg";
import logoutIcon from "./icons/sidebar-logout.svg";
import walletArrowIcon from "./icons/sidebar-wallet-arrow.svg";
import customerServiceIcon from "./icons/sidebar-customer-service.svg";

const iconMap = {
	order: orderIcon,
	follow: followIcon,
	message: messageIcon,
	coupon: couponIcon,
	file: fileIcon,
	address: addressIcon,
	account: accountIcon,
	logout: logoutIcon,
	"wallet-arrow": walletArrowIcon,
	"customer-service": customerServiceIcon,
};

const props = defineProps({
	name: {
		type: String,
		required: true,
	},
	size: {
		type: [Number, String],
		default: 24,
	},
	alt: {
		type: String,
		default: "",
	},
});

const iconSrc = computed(() => iconMap[props.name] || "");
const iconStyle = computed(() => {
	const size = typeof props.size === "number" ? `${props.size}px` : props.size;

	return {
		width: size,
		height: size,
	};
});
</script>

<style lang="scss" scoped>
.sidebar-icon {
	display: block;
	flex-shrink: 0;
	object-fit: contain;
}
</style>
